import languageCode from '@/constants/languageCode';

class LoadMapScriptService {
  #loadPromise = null;

  load() {
    if (!this.#loadPromise) {
      this.#loadPromise = LoadMapScriptService.#loadMapScript();
    }

    return this.#loadPromise;
  }

  static #loadMapScript() {
    return new Promise((resolve) => {
      const apiKey = process.env.NUXT_ENV_GOOGLE_MAPS_API_KEY;
      const script = document.createElement('script');

      window.initGoogleMap = resolve;
      script.async = true;
      script.defer = true;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initGoogleMap&libraries=places,drawing,geometry&language=${languageCode.EN}`;
      document.querySelector('head').appendChild(script);
    });
  }
}

export default new LoadMapScriptService();
